import {EmailMediumDTO} from "./emailMediumDTO.interface";
import {BaseDTO} from "./_baseDTO.interface";

export interface EmailDTO extends BaseDTO {
  emailMedia: EmailMediumDTO[];
}
